<template>
	<div>
		<el-input
	  type="textarea"
	  :autosize="{ minRows: 10, maxRows: 20}"
	  placeholder="请输入设备名称，每行一个"
	  v-model="stationFiltersModel">
	</el-input>
	<div class="dialog-footer" style="text-align: right;margin-top: 20px;">
    <el-button type="primary" @click="chooseStationFilterList">确 定</el-button>
  </div>
	</div>
	
</template>

<script>
export default {
	name:'StationFilter',
	prop:{
		stationFilterVisable: Boolean
	},
	data(){
		return {
			stationFilters: '',
			stationFiltersModel: ''
		}
	},
	watch:{
		stationFilterVisable(){
			console.log(this.stationFilterVisable)
			if (this.stationFilterVisable){
				this.stationFiltersModel = this.stationFilters		
			}
		}
	},
	mounted(){
		console.log('mounted')
	},
	methods:{
		chooseStationFilterList(){
			// console.log(this.stationFilterList)
			this.stationFilters = this.stationFiltersModel
			var stationFilterList = this.stationFilters.split('\n')
			this.$emit('chooseStationFilterList', stationFilterList)
		}
	}
}
</script>


// WEBPACK FOOTER //
// src/components/StationFilter.vue